import { render } from "./BannerSetting.vue?vue&type=template&id=42809ab0&scoped=true"
import script from "@/assets/js/banner.js?vue&type=script&lang=js&external"
export * from "@/assets/js/banner.js?vue&type=script&lang=js&external"

import "@/assets/css/banner.css?vue&type=style&index=0&id=42809ab0&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42809ab0"]])

export default __exports__